exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.white-space[data-v-80d1ab8e]{\r\n     height:24px;\n}\r\n", "", {"version":3,"sources":["/app/src/components/_widget/src/components/_widget/WhiteSpace.vue"],"names":[],"mappings":";AAIA;KACA,YAAA;CACA","file":"WhiteSpace.vue","sourcesContent":["<template>\r\n    <div class=\"white-space\"></div>\r\n</template>\r\n<style scoped>\r\n.white-space{\r\n     height:24px;\r\n}\r\n</style>"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-80d1ab8e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/_widget/WhiteSpace.vue
// module id = B7V3
// module chunks = 72